module.exports = __webpack_public_path__ + "static/media/broadcastWhite.671fbbc9.svg";